<p-dialog
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="w-full max-w-4xl"
  data-testid="decision-reason-modal"
>
  <ng-template #header>
    <h2 class="text-xl font-semibold">
      @if (tool()?.translatedName) {
        {{ tool()?.translatedName }}
      } @else {
        {{ 'project.steps.invitationList.reason' | transloco }}
      }
    </h2>
  </ng-template>

  <div class="flex flex-col gap-4">
    <div>
      <label class="block mb-2 font-medium" for="decision-main-reason">
        {{ 'project.steps.invitationList.reasonMain' | transloco }}
      </label>

      <p-select
        inputId="decision-main-reason"
        [options]="mainReasonOptions()"
        [ngModel]="mainReasonId()"
        (ngModelChange)="onMainReasonChange($event)"
        optionLabel="label"
        optionValue="value"
        class="w-full"
        [placeholder]="'common.pleaseSelect' | transloco"
        [disabled]="isStepFinished()"
        data-testid="main-reason-select"
      />
    </div>

    <div>
      <div class="block mb-2 font-medium">
        {{ 'project.steps.invitationList.reasonDetails' | transloco }}
      </div>

      <div class="flex flex-col gap-2">
        @for (reason of detailReasonOptions(); track reason.value) {
          <div class="flex items-center gap-2">
            <p-checkbox
              [inputId]="'detail-reason-' + reason.value"
              [ngModel]="isDetailReasonSelected(reason.value)"
              (ngModelChange)="onDetailReasonToggle(reason.value, $event)"
              [binary]="true"
              [disabled]="isStepFinished()"
            />
            <label [for]="'detail-reason-' + reason.value" class="cursor-pointer">
              {{ reason.label }}
            </label>
          </div>
        }
      </div>
    </div>

    <div>
      <label class="block mb-2 font-medium" for="decision-generated-text">
        {{ 'project.steps.invitationList.reasonGenerated' | transloco }}
      </label>
      <textarea
        id="decision-generated-text"
        pTextarea
        class="w-full min-h-28"
        [ngModel]="generatedText()"
        (ngModelChange)="onGeneratedTextChange($event)"
        [disabled]="isStepFinished()"
        data-testid="generated-text-textarea"
      ></textarea>
      <div class="flex justify-between items-center mt-2">
        <span class="text-sm text-gray-500">{{ generatedText().length }} / 50</span>
        <p-button
          [label]="'project.steps.invitationList.reasonGenerate' | transloco"
          severity="secondary"
          [disabled]="!canGenerate()"
          [loading]="loading()"
          (onClick)="generate()"
          data-testid="generate-decision-reason-btn"
        />
      </div>
    </div>

    <p class="text-sm text-gray-500 mb-2">
      {{ 'project.steps.invitationList.reasonGenerated.help' | transloco }}
    </p>

    <div>
      <label class="block mb-2 font-medium" for="decision-comment">
        {{ 'project.steps.invitationList.reasonComment' | transloco }}
      </label>
      <textarea
        id="decision-comment"
        pTextarea
        class="w-full min-h-24"
        [ngModel]="comment()"
        (ngModelChange)="onCommentChange($event)"
        [disabled]="isStepFinished()"
      ></textarea>
    </div>

    <div class="flex justify-end gap-2 pt-2">
      <p-button [label]="'common.cancel' | transloco" severity="secondary" (onClick)="close()" />
      <p-button
        [label]="'common.save' | transloco"
        [disabled]="!canSave()"
        [loading]="loading()"
        (onClick)="save()"
        data-testid="save-decision-reason-btn"
      />
    </div>
  </div>
</p-dialog>
